import React, { useContext } from 'react';
import Moment from 'react-moment';
import { formatPrice, getSystemSettings } from "../../../functions/Functions";
import { SettingsContext } from '../../../contexts/Settings';

const ReportExcelPrintGap = (props) => {
  const { generalSettings } = useContext(SettingsContext);
  const {
    header,
    viewDetailReport = null,
    generatedReport,
    heading,
    reportData,
    startDate,
    endDate,
    branch,
    printRef,
    type = "print"
  } = props;

  let g_total = {};
  let groupTotals = {}

  const sumAmounts = (value, key) => {
    const amount = parseFloat(value);
    if (!isNaN(amount)) {
      // Accumulate numeric values dynamically
      groupTotals[key] = (groupTotals[key] || 0) + amount;
      g_total[key] = (g_total[key] || 0) + amount;
    }
  };

  const tableBody = (data) => {
    // BASE CASES
    if (!data) return null;
    if (data) {
      if (type === "excel") {
        if (Array.isArray(data)) {
          if (data?.length) {
            return (
              <>
                {data.map((item, index) => {
                  return (
                    <tr key={index}>
                      {header.map((col, idx) => {
                        // Accumulate sums for numeric columns
                        if (col?.total) {
                          const totalAmt = typeof col?.render === "function" ? col.render(item) : item[col?.key];
                          if(col?.key && !isNaN(totalAmt)){
                            sumAmounts(totalAmt, col?.key);
                          }
                        }

                        if (typeof col?.render === "function") {
                          return (
                            <td key={idx}>
                              {col.render(item, index)}
                            </td>
                          );
                        }

                        if (col?.key) {
                          return <td key={idx}>{item[col?.key]}</td>;
                        }

                      
                      })}
                    </tr>
                  );
                })}
              </>
            )
          }
        } else {
          const keys = Object.keys(data);
          if (!keys.length) return null;
          return (
            <>
              {keys.map((item, index) => {
                groupTotals = {};
                const child = data[item];
                return (
                  <>
                    <tr key={index}>
                      <th>{item}</th>
                    </tr>
                    {tableBody(child)}
                    {Array.isArray(child) && !branch?.removeTotal && (
                      <tr>
                        {header.map((col, i) => {
                          const totalValue = groupTotals[col.key];
                          return (
                            <td style={{ fontSize: "0.77rem" }}>
                              <strong>
                                {i === 0
                                  ? `${item} Total` :
                                  totalValue !== undefined && totalValue !== null && totalValue !== ""
                                    ? formatPrice(totalValue)
                                    : ""}
                              </strong>
                            </td>
                          )
                        })}
                      </tr>
                    )}
                    <tr></tr>
                  </>
                );
              })}
            </>
          )
        }
      } else {
        if (Array.isArray(data)) {
          if (data?.length) {
            return (
              <>
                {data.map((item, index) => {
                  return (
                    <tr key={index}>
                      {
                        header.map((col, i) => {
                          if(col?.total){
                            const totalAmt = typeof col?.render === "function" ? col.render(item) : item[col?.key];
                            if(col?.key && !isNaN(totalAmt)){
                              sumAmounts(totalAmt, col?.key)
                            }
                          }

                          if (typeof col?.render === "function") {
                            return (
                              <td key={i} className={`${i === 0 ? "table_child_total" : ""} text-capitalize align-middle border-1 border sm-text`}>
                                {col.render(item, index)}
                              </td>
                            );
                          }

                          if(col.key){
                            return <td key={i} className={`${i === 0 ? "table_child_total" : ""} text-capitalize align-middle border-1 border sm-text`}>{item[col.key]}</td>
                          }
                        })
                      }
                    </tr>
                  );
                })}
              </>
            )
          }
        } else {
          const keys = Object.keys(data);
          if (!keys.length) return null;
          return (
            <>
              {keys.map((item, index) => {
                groupTotals = {};
                const child = data[item];
                return (
                  <>
                    <tr key={index}>
                      <th style={{ fontSize: "0.77rem" }} className={`${index === 0 ? "table_child_total" : ""} text-capitalize align-middle border-1 border`}>{item}</th>
                      <td className="text-capitalize align-middle border-1 border " colSpan={header.length - 1}></td>
                    </tr>
                    {tableBody(child)}
                    {Array.isArray(child) && !branch?.removeTotal && (
                      <tr>
                        {header.map((col, i) => {
                          const totalValue = groupTotals[col.key];
                          return (
                            <th style={{ fontSize: "0.77rem" }} className={`${i === 0 ? "table_child_total" : ""} text-capitalize align-middle border-1 border`}>
                              {i === 0
                                ? `${item} Total` :
                                totalValue !== undefined && totalValue !== null && totalValue !== ""
                                  ? formatPrice(totalValue)
                                  : ""}
                            </th>
                          )
                        })}
                      </tr>
                    )}
                    <tr style={{ height: "5px" }}></tr>
                  </>
                );
              })}
            </>
          )
        }
      }
    }
  };

  const tableHeading = () => {
    return (
      <>
        <h3 className="text-center xslg-text my-2">
          {getSystemSettings(generalSettings, "siteName")}
        </h3>
        <h3 className="text-center xslg-text my-2">
          {heading}
        </h3>
        {
          branch?.show && branch?.name && (
            <p className="text-center my-2">
              {branch.name}
            </p>
          )
        }
        {!viewDetailReport && (
          <p className="text-center my-2">
            {
              startDate && endDate ? (
                <>
                  FROM&nbsp;
                  <Moment format="LL">
                    {startDate}
                  </Moment>
                  &nbsp;TO&nbsp;
                  <Moment format="LL">{endDate}</Moment>
                </>
              ) : (
                <>
                  Date&nbsp;
                  <Moment format="LL">
                    {startDate}
                  </Moment>
                </>
              )
            }
          </p>
        )}
      </>
    );
  }

  return (
    <>
      <div className={`${viewDetailReport ? "" : "d-none"}`}>
        <div ref={printRef}>
          {reportData && generatedReport ? (
            <div className="fk-print container-fluid mt-3">
              <div style={{ maxHeight: viewDetailReport ? "23rem" : "auto" }} className={`${viewDetailReport ? "bill_modal_scroll" : ""}`}>
                {type !== "excel" && (
                  tableHeading()
                )}
                <>
                  <table id="table-to-xls" className="table table-bordered table-hover mt-2">
                    {type === "excel" && (
                      <>
                        <tr>
                          <th colspan={header.length}>
                            {tableHeading()}
                          </th>
                        </tr>
                        <tr></tr>
                      </>
                    )}
                    {
                      (Object.keys(reportData)?.length || reportData?.length) ? (
                        <>
                          <thead className="align-middle">
                            {
                              viewDetailReport ? (
                                <tr style={{
                                  position: 'sticky', top: '-0.1px', backgroundColor: 'white'
                                }}>
                                  {
                                    header.map((col, i) => (
                                      <th
                                        key={i}
                                        scope="col"
                                        className="border-1 border"
                                        style={{ 
                                          fontSize: "0.77rem",
                                          ...(col.name?.toLowerCase()?.includes("group") && { minWidth: "165px" })
                                        }}
                                      >
                                        {col.name}
                                      </th>
                                    ))
                                  }
                                </tr>
                              ) : (
                                <tr>
                                  {
                                    header.map((col, i) => (
                                      <th
                                        key={i}
                                        scope="col"
                                        className="border-1 border"
                                        style={{ 
                                          fontSize: "0.77rem",
                                          ...(col.name?.toLowerCase()?.includes("group") && { minWidth: "180px" })
                                        }}
                                      >
                                        {col.name}
                                      </th>
                                    ))
                                  }
                                </tr>
                              )
                            }
                          </thead>
                          <tbody className="align-middle">
                            {tableBody(reportData)}
                            {!branch?.removeTotal && (
                                <tr>
                                  {header.map((col, i) => {
                                    const totalValue = g_total[col.key];
                                    return (
                                      <td style={{ fontSize: "0.77rem" }} className="text-capitalize align-middle border-1 border">
                                        <strong>
                                          {i === 0
                                            ? `Grand Total` :
                                            totalValue !== undefined && totalValue !== null && totalValue !== ""
                                              ? formatPrice(totalValue)
                                              : ""}
                                        </strong>
                                      </td>
                                    )
                                  })}
                                </tr>
                              )
                            }
                          </tbody>
                        </>
                      ) : ""
                    }
                  </table>
                </>
              </div>
            </div>
          ) : ""}
        </div>
      </div>
    </>
  )
}

export default ReportExcelPrintGap